import { toast } from 'vue-sonner';
import { isAuthCode, getToken, clearToken, gotoLogin } from './auth';
import {
  $fetch as baseFetch,
  DEFAULT_ERROR_CODE,
  type FetchOptions,
  type FetchResult,
} from './base-fetch';
import {
  HEADER_KEY_SITE,
  HEADER_KEY_LANGUAGE,
  HEADER_KEY_TOKEN,
  DEFAULT_LANGUAGE,
  SITE_CODE,
} from './constants';

export type {
  FetchOptions,
  FetchResult,
} from './base-fetch';

export async function $fetch<ResT = any, DataT = any>(url: string, inputOptions: FetchOptions<DataT> = {}): Promise<FetchResult<ResT>> {
  const token = getToken();

  const headers: Record<string, any> = {
    [HEADER_KEY_SITE]: SITE_CODE,
    [HEADER_KEY_LANGUAGE]: DEFAULT_LANGUAGE,
  }
  token && (headers[HEADER_KEY_TOKEN] = token);

  const result = await baseFetch<ResT, DataT>(url, {
    headers,
    ...inputOptions,
  });

  if (!result.isSuccess) {
    if (isAuthCode(Number(result.code))) {
      toast.error('你已被登出，请重新登录', {
        action: {
          label: '重新登录',
          onClick: () => {
            clearToken();
            gotoLogin();
          },
        },
        duration: Infinity,
      });
    }
    else {
      if (inputOptions.errorMessage !== false) {
        if (result.code === DEFAULT_ERROR_CODE) {
          toast.error(`网络请求出错! API: ${url} ; 错误信息: ${result.msg}`);
        }
        else {
          toast.error((inputOptions.errorMessage as string) || result.msg || '请求出错！请联系客服或稍后再试！');
        }
      }
    }
  }

  return result;
}
